import script from "./FormerContractDebts.vue?vue&type=script&setup=true&lang=js"
export * from "./FormerContractDebts.vue?vue&type=script&setup=true&lang=js"

import "./FormerContractDebts.vue?vue&type=style&index=0&id=6d686e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d686e42"]])

export default __exports__